import request from "utils/request"
import requestJWT from "utils/requestJWT"

const getImgByTour = async (id) => {
    try {
        const res = await request.get(`/image_description/${id}/get-by-tour`)
        return res.data
    } catch (error) {
        console.log(error);
    }
}

const create = async (formData) => {
    return await requestJWT.post(`/image_description/create`, formData)
}

const remove = async (id) => {
    return await requestJWT.delete(`/image_description/${id}/remove`)
}

export { getImgByTour, create, remove }